/* global jQuery, document, window */

jQuery(document).ready(function ($) {

	/* HTML5 Placeholder
	   ========================================================================== */

	$('input, textarea').placeholder();

	/* Table Responsive
	   ========================================================================== */

	$('table.table-responsive').each(function () {
		var self = $(this);
		if (!self.parent().is('.table-responsive-wrap'))
			self.addClass('table-responsive').wrap('<div class="table-responsive-wrap"></div>');
	});

	/* Tabbed
	   ========================================================================== */

	// Main

	$('.tabbed-main').each(function () {
		var component = $(this);
		$(component.find('.main-active a').attr('href')).show();
		component.find('.main-tabs .main-tab-item a').click( function () {
			var link      = $(this),
				wrapper   = link.closest(component),
				activeTab = wrapper.find('.main-active a');

			$( activeTab.attr('href') ).hide();
			activeTab.parent().removeClass('main-active');
			link.parent().addClass('main-active');
			$( link.attr('href') ).fadeIn('300');


			return false;
		});
	});

	$('.main-tab-item-primary a').click(function () {
		$('.banner-secondary').removeClass('banner-active');
		$('.banner-tertiary').removeClass('banner-active');
		$('.banner-primary').addClass('banner-active');
	});

	$('.main-tab-item-secondary a').click(function () {
		$('.banner-primary').removeClass('banner-active');
		$('.banner-tertiary').removeClass('banner-active');
		$('.banner-secondary').addClass('banner-active');
	});

	$('.main-tab-item-tertiary a').click(function () {
		$('.banner-primary').removeClass('banner-active');
		$('.banner-secondary').removeClass('banner-active');
		$('.banner-tertiary').addClass('banner-active');
	});

	// Secondary / Tertiary

	$('.tabbed-secondary, .tabbed-tertiary').each(function () {
		var component = $(this);
		component.find('.tabs .tab-item a').click( function () {
			var link      = $(this),
				wrapper   = link.closest(component),
				activeTab = wrapper.find('.active a');

			$( activeTab.attr('href') ).hide();
			activeTab.parent().removeClass('active');
			link.parent().addClass('active');
			$( link.attr('href') ).fadeIn('300');

			var width = $(window).width(); // Checking size again after window resize
			if ( width > 768 ) {
				return false;
			}
		});
	});

	$('.gmaps').click(function () {
    $('.gmaps iframe').css("pointer-events", "auto");
	});

	$( ".gmaps" ).mouseleave(function() {
	  $('.gmaps iframe').css("pointer-events", "none");
	});

	/* Popup Handler
	   ========================================================================== */

	$('.schedule-popup-link').click(function () {
		var $importantpopup = $('.schedule-popup');

		if ($(window).width() < 768) {
			$importantpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $importantpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$importantpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.schedule-popup').addClass('display-none');
		return false;
	});

	$('.important-info-popup-link').click(function () {
		var $importantpopup = $('.important-info-popup');

		if ($(window).width() < 768) {
			$importantpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $importantpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$importantpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.important-info-popup').addClass('display-none');
		return false;
	});


	$('.basic-popup-link').click(function () {
		var $basicpopup = $('.basic-popup');

		if ($(window).width() < 768) {
			$basicpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $basicpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$basicpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.basic-popup').addClass('display-none');
		return false;
	});



	$('.test-description-popup-link').click(function () {
		var $testdescriptionpopup = $('.test-description-popup');

		if ($(window).width() < 768) {
			$testdescriptionpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $testdescriptionpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$testdescriptionpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.test-description-popup').addClass('display-none');
		return false;
	});


	$('.targeted-popup-link').click(function () {
		var $targetedpopup = $('.targeted-popup');

		if ($(window).width() < 768) {
			$targetedpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $targetedpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$targetedpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.targeted-popup').addClass('display-none');
		return false;
	});



	$('.academic-popup-link').click(function () {
		var $academicpopup = $('.academic-popup');

		if ($(window).width() < 768) {
			$academicpopup.removeClass('display-none');
            $('html, body').animate({ scrollTop: $academicpopup.offset().top });
		} else {
			/*$(document.body).css('overflow', 'hidden');*/
			$("#modal-bg").fadeTo(0).removeClass('display-none').fadeTo('slow', 0.5);
			$academicpopup.fadeTo(0).removeClass('display-none').fadeTo('slow', 1);
		}

		return false;
	});

	$('.popup-close').click(function () {
		$(document.body).css('overflow', 'auto');
		$("#modal-bg").addClass('display-none');
		$(this).closest('.academic-popup').addClass('display-none');
		return false;
	});




	$(document).mouseup(function (e) {
		if ($(window).width() > 768) {
		    var container = $(".popup");

		    if (!container.is(e.target) // if the target of the click isn't the container...
		        && container.has(e.target).length === 0) // ... nor a descendant of the container
		    {
		        container.addClass('display-none');
		        $("#modal-bg").addClass('display-none');
		    }
		}
	});
	/* Match Height
	   ========================================================================== */

	// apply matchHeight to each item container's items
	$('.match-height').each(function() {
		$(this).find('.common-height').matchHeight();
	});

}); // end.ready